/* eslint-disable no-shadow */

export enum IssueTypeEnum {
  SINGLE = "SINGLE",
  RECURRENT = "RECURRENT",
}

export const IssueTypeLabels = {
  [IssueTypeEnum.SINGLE]: "Nota Avulsa",
  [IssueTypeEnum.RECURRENT]: "Nota Recorrente",
};

export const IssueTypeList = [
  { label: IssueTypeLabels[IssueTypeEnum.SINGLE], value: IssueTypeEnum.SINGLE },
  { label: IssueTypeLabels[IssueTypeEnum.RECURRENT], value: IssueTypeEnum.RECURRENT },
];